import { createReactComponent } from '@tabler/icons-react';

export const IconCustomBoltRestore = createReactComponent(
  'outline',
  'customBoltRestore',
  'CustomBoltRestore',
  [
    [
      'path',
      {
        key: 'iconCustomBoltRestore-path',
        d: 'M14.5834 10.0521L15.8334 8.33333H10.8334V2.5L4.16669 11.6667H9.16669V17.5L10.4167 15.7812M12.6875 14.3694C12.9437 13.7544 13.3951 13.2407 13.972 12.9074C14.5489 12.5741 15.2194 12.4397 15.8801 12.525C16.5409 12.6102 17.1553 12.9104 17.6288 13.3792C17.8465 13.5949 18.0289 13.8407 18.1713 14.1076M12.5 12.8694V14.3694H14M18.3125 16.6194C18.0563 17.2344 17.605 17.7482 17.0281 18.0814C16.4512 18.4147 15.7807 18.5491 15.1199 18.4638C14.4591 18.3786 13.8447 18.0784 13.3713 17.6096C13.1862 17.4263 13.0267 17.2213 12.8956 17M18.5 18.1194V16.6194H17',
      },
    ],
  ]
);
